import React from 'react';
import { Check } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
const summaryItems = ['Sistema completo para cocinar 15 días en 2 horas', '200 recetas optimizadas para freezer', '7 bonos incluidos (Solo por hoy)', 'Ahorro en deliverys de +$300.000/mes', 'Más tiempo libre', 'Pago único — Sin cargos mensuales', 'Acceso inmediato', 'Garantía 30 días'];
export function FinalSummary() {
  return <section className="py-5 md:py-7 px-4 bg-white text-text-primary" data-id="element-70">
      <div className="max-w-2xl mx-auto" data-id="element-71">
        <h2 className="text-lg md:text-2xl text-center mb-4 md:mb-5 font-bold italic font-italic tracking-tight" data-id="element-72">
          Una Vez Más, Todo Lo Que Recibís
        </h2>

        <div className="border border-black/10 rounded-2xl p-3 md:p-5 mb-4 md:mb-5 bg-[#F7F5F0] shadow-sm" data-id="element-73">
          <ul className="space-y-2 md:space-y-2.5" data-id="element-74">
            {summaryItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-75">
                <Check className="text-primary shrink-0 mt-0.5" size={16} strokeWidth={3} data-id="element-76" />
                <span className="text-sm md:text-base font-bold text-text-primary/90 leading-relaxed" data-id="element-77">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="text-center mb-4 md:mb-5" data-id="element-78">
          <p className="text-xs md:text-sm text-text-primary/50 font-bold uppercase tracking-widest mb-2" data-id="element-79">
            Valor total: <span className="line-through" data-id="element-80">$144.930 ARS</span>
          </p>
          <p className="text-xl md:text-3xl font-bold italic font-italic text-text-primary" data-id="element-81">
            Pago único hoy:{' '}
            <span className="text-primary" data-id="element-82">
              <PriceDisplay amount={19990} className="inline text-xl md:text-3xl font-black text-primary tracking-tight" data-id="element-83" />
            </span>
          </p>
        </div>

        <CTAButton large data-id="element-84">QUIERO ACCEDER</CTAButton>

        <p className="text-xs md:text-sm text-center text-text-primary/60 mt-2 md:mt-3 font-bold uppercase tracking-widest" data-id="element-85">
          Acceso inmediato a 200 Recetas Inteligentes 15D + todos los bonos
        </p>
      </div>
    </section>;
}